export default "__VITE_ASSET__4a2af3a8__"